import React, { useState, useEffect } from "react";

const UserModal = ({ user, onClose }) => {
  if (!user) return null;
  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6 overflow-y-auto max-h-[90vh]">
        
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-xl font-semibold text-gray-800">User Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-lg"
          >
            ✕
          </button>
        </div>
      <div className="flex flex-wrap item-center justify-center gap-4">
        <div><img src={user.avatar} alt="" srcset="" className="rounded-full"/></div>
      
        
        <div className="flex flex-col items-left">
          <h3 className="text-2xl font-bold text-gray-900">{user.name}</h3>
          <p className="text-gray-600">{user.email}</p>
        </div>
        </div>

        
        <div className="mt-6 grid grid-cols-2 gap-6 text-sm">
          <div>
            <p className="font-semibold text-gray-700">Role:</p>
            <p className="text-gray-600">{user.role_name}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">Reference Code:</p>
            <p className="text-gray-600">{user.reference_code}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">School Count:</p>
            <p className="text-gray-600">{user.schoolCount || "N/A"}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">Created At:</p>
            <p className="text-gray-600">{formatDateTime(user.created_at)}</p>
          </div>
        </div>

       
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;

const formatDateTime = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  return isNaN(date.getTime()) ? value : date.toLocaleString();
};
